export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  attrs?: Record<string, string>,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (attrs) {
    for (const key of Object.keys(attrs)) {
      const value = attrs[key];
      if (value !== undefined) node.setAttribute(key, value);
    }
  }
  return node;
}

/** Gom listener lại một chỗ để `destroy()` gỡ sạch — widget bị nhúng vào SPA
 *  của khách, rò listener là rò luôn cả cây DOM. */
export class Listeners {
  private items: Array<[EventTarget, string, EventListener, AddEventListenerOptions | undefined]> = [];

  add<T extends EventTarget>(
    target: T | null | undefined,
    type: string,
    handler: EventListener,
    options?: AddEventListenerOptions,
  ): void {
    if (!target) return;
    target.addEventListener(type, handler, options);
    this.items.push([target, type, handler, options]);
  }

  clear(): void {
    for (const [target, type, handler, options] of this.items) {
      target.removeEventListener(type, handler, options);
    }
    this.items = [];
  }
}
